<template>
    <ModalFormCard class="modal-default" :action="action" v-bind="{ errors, saving }">
        <template #title>Events on {{ data.day.date.format('DD/MM/YYYY') }} ({{ data.day.date.format('dddd') }})</template>

        <template v-for="event in data.events.filter((e) => e.ends_at != null)">
            <div
                @click="
                    () => {
                        this.$event.$emit('modal-open', {
                            view: 'TaskView',
                            editingModel: event,
                        })
                    }
                "
                class="text-14 flex items-center h-[26px] mb-1"
                :class="{
                    'bg-blue-600 text-white px-2': event.appointment == 1 && !event.isPast,
                    'bg-purple-600 text-white px-2': event.appointment == 0 && !event.isPast,
                }"
            >
                <p class="font-semibold truncate max-w-[60%]">{{ event.title }}</p>
                <p class="pl-2 text-white opacity-70">({{ event.durationHuman() }})</p>
            </div>
        </template>

        <div class="pt-3">
            <template v-for="event in data.events.filter((e) => e.ends_at == null)">
                <div
                    class="border-b border-grey-500 flex justify-between items-center py-1"
                    @click="
                        () => {
                            this.$event.$emit('modal-open', {
                                view: 'TaskView',
                                editingModel: event,
                            })
                        }
                    "
                >
                    <div class="flex items-center">
                        <div
                            class="w-2 h-2 rounded-full shrink-0 mr-3 hidden md:block"
                            :class="{
                                'bg-grey-800': event.isPast,
                                'bg-purple-500': event._type() == 'task' && !event.isPast,
                                'bg-blue-600': event._type() == 'appointment' && !event.isPast,
                            }"
                        />

                        <p class="text-14 link-text">{{ event.title }}</p>
                    </div>

                    <p class="text-14 text-grey-800 hidden md:block">{{ event.time(true) }}</p>
                    <!-- <p class="text-14 text-grey-900">{{ event.durationHuman() }}</p> -->
                </div>
            </template>
        </div>

        <!-- <div
            v-for="event in data.events"
            @click="
                () => {
                    this.$event.$emit('modal-open', {
                        view: 'TaskView',
                        editingModel: event,
                    })
                }
            "
            class="flex items-center h-7 text-11 lg:text-13 md:rounded-tl-[12px] rounded-tl-[6px] md:rounded-br-[12px] rounded-br-[6px] mb-2"
            :class="{
                'bg-blue-600 text-white md:px-3 px-1': !event.single && event.appointment == 1 && !event.isPast,
                'bg-purple-600 text-white md:px-3 px-1': !event.single && event.appointment == 0 && !event.isPast,
                'px-0.5 md:px-2': event.single,
                'bg-grey-400': !event.single && event.isPast,
                'text-grey-800 px-1 md:px-3': event.isPast,
            }"
        >
            <template v-if="event.single ">
                <div
                    class="w-2 h-2 rounded-full shrink-0 mr-2 hidden md:block"
                    :class="{
                        'bg-grey-800': event.isPast,
                        'bg-purple-500': event._type() == 'task' && !event.isPast,
                        'bg-blue-600': event._type() == 'appointment' && !event.isPast,
                    }"
                />

                <p class="text-12 pr-2 text-grey-800 hidden md:block">{{ event.time(true) }}</p>
            </template>

            <p class="truncate">{{ event.title }}</p>
        </div> -->

        <div class="modal-buttons">
            <button class="button-black default">Go to week</button>
            <button class="button-black default">Go to day</button>
        </div>
    </ModalFormCard>
</template>

<script>
import Modal from '~/mixins/modal.js'

export default {
    mixins: [Modal],

    computed: {
        data() {
            return this.editingModel
        },
    },
}
</script>
